import React, {useState} from "react";
import rocket from "./assets/rocket.png";
import note from "./assets/note.png";
import NftCard from "../../../GlobalComponents/NftCard/NftCard";
import thum from "./assets/thum.png";
import thum2 from "./assets/thum2.png";
const Banner = () => {
  const handleExp = () => {
    window.location.href = "/explore";
  };
  const handleList = () =>{
    window.location.href = "/my-profile";
  }
  return (
    <div className="container pt-[30px] md:pt-[174px] pb-[156px]">
      <div className="max-w-[1188px] mx-auto">
        <div className="flex lg:flex-row flex-col gap-x-[20px] gap-y-[80px] xl:gap-[95px]">
          <div className="xl:max-w-[657px] max-w-[500px] xl:w-full  flex-none ">
            <h2 className="text-[36px] leading-[48px] md:text-[56px] md:leading-[68px] font-black">
              Unlock exclusive benefits and opportunities with
              <span className="text-bright-green"> R34P</span> DAO NFTs.
            </h2>
            <p className="text-[#EBEBEB] pb-[36px] text-res-sm leading-[30px] font-semibold">
              {" "}
              Own a Piece of the Future of Decentralized Finance
            </p>
            <div className="flex gap-[16px]">
              <button
                onClick={handleExp}
                className="flex items-center justify-center w-[154px] h-14 border rounded-[30px] border-solid border-main-green text-[15px] leading-[22px]"
              >
                <img src={rocket} alt="" />
                <span className="font-bold">Explore</span>
              </button>
              <button onClick={handleList} className="flex justify-center items-center text-main-black bg-custom-gradient w-[147px] h-[56px] rounded-[20px] gap-[8px] font-bold text-[15px] leading-[22px]">
                <img src={note} alt="" />
                <p>LIST</p>
              </button>
            </div>
          </div>
          <div className="grow  flex justify-center">
            <div className="inline-block ">
              <div className="relative">
                <div className="relative z-10">
                  <NftCard thum={thum}></NftCard>
                </div>
                <div className="absolute origin-bottom-right hidden xl:block inset-0 rotate-[11deg]">
                  <NftCard thum={thum2}></NftCard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
